/**
 * Cafe POI Icon - Coffee cup icon for cafe markers
 *
 * Used in POI markers with circular colored backgrounds.
 * Original asset: Cafe.svg (16x16px, white fill)
 */

import React from 'react';

export type CafeIconProps = {
  size?: string | number;
  color?: string;
  className?: string;
};

/**
 * Cafe icon SVG content for use in POI markers
 */
export const CAFE_ICON_PATH = `<path fill-rule="evenodd" clip-rule="evenodd" d="M6 12.5C3.5 12.5 3.0103 9.43248 3 4.11795C2.99881 3.50069 3.44709 3 3.99946 3H11.0005C11.5529 3 12.0012 3.50069 12 4.11795C11.9997 4.25325 11.9992 4.38709 11.9983 4.51946C12.3164 4.54429 12.6499 4.60057 12.947 4.7279C13.24 4.85349 13.5153 5.05368 13.7122 5.36638C13.9072 5.67607 14 6.05597 14 6.49997C14 7.32648 13.7922 8.00108 13.2576 8.44658C12.8524 8.7842 12.3236 8.93381 11.7325 8.98171C11.3814 11.2567 10.6095 12.5 9 12.5H6ZM11.8568 7.96242C12.2164 7.91165 12.4572 7.81185 12.6174 7.67836C12.8328 7.49886 13 7.17346 13 6.49997C13 6.19397 12.9366 6.01137 12.8659 5.89919C12.7972 5.79001 12.6975 5.70895 12.553 5.64704C12.3924 5.57818 12.201 5.54146 11.9846 5.52193C11.9651 6.41422 11.9258 7.22938 11.8568 7.96242Z" fill="white"/><path d="M3 13.5C3 13.2239 3.22386 13 3.5 13H11.5C11.7761 13 12 13.2239 12 13.5C12 13.7761 11.7761 14 11.5 14H3.5C3.22386 14 3 13.7761 3 13.5Z" fill="white"/>`;

/**
 * React component for cafe icon (optional, for direct usage)
 */
export const CafeIcon: React.FC<CafeIconProps> = ({ size = 16, color = 'currentColor', className }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 12.5C3.5 12.5 3.0103 9.43248 3 4.11795C2.99881 3.50069 3.44709 3 3.99946 3H11.0005C11.5529 3 12.0012 3.50069 12 4.11795C11.9997 4.25325 11.9992 4.38709 11.9983 4.51946C12.3164 4.54429 12.6499 4.60057 12.947 4.7279C13.24 4.85349 13.5153 5.05368 13.7122 5.36638C13.9072 5.67607 14 6.05597 14 6.49997C14 7.32648 13.7922 8.00108 13.2576 8.44658C12.8524 8.7842 12.3236 8.93381 11.7325 8.98171C11.3814 11.2567 10.6095 12.5 9 12.5H6ZM11.8568 7.96242C12.2164 7.91165 12.4572 7.81185 12.6174 7.67836C12.8328 7.49886 13 7.17346 13 6.49997C13 6.19397 12.9366 6.01137 12.8659 5.89919C12.7972 5.79001 12.6975 5.70895 12.553 5.64704C12.3924 5.57818 12.201 5.54146 11.9846 5.52193C11.9651 6.41422 11.9258 7.22938 11.8568 7.96242Z"
        fill={color}
      />
      <path
        d="M3 13.5C3 13.2239 3.22386 13 3.5 13H11.5C11.7761 13 12 13.2239 12 13.5C12 13.7761 11.7761 14 11.5 14H3.5C3.22386 14 3 13.7761 3 13.5Z"
        fill={color}
      />
    </svg>
  );
};
